/* Bene · JS das sections (Fase 3)
 * Código que antes era inline dentro de cada section/snippet (≈70 KB por página, repetido a cada instância).
 * Cada section registra só uma linha: beneRun('nome', {config}); o código correspondente roda aqui, com defer.
 * Para editar o comportamento de uma section, edite o bloco dela abaixo (a fonte original ficou em scripts/ da pasta velocidade-fase3).
 */
(function () {
  'use strict';
  var inits = {};
  function register(name, fn) { inits[name] = fn; }
  function run(name, cfg) {
    var fn = inits[name];
    if (!fn) { if (window.console) console.warn('[bene-sections] init desconhecido:', name); return; }
    try { fn(cfg || {}); } catch (e) { if (window.console) console.error('[bene-sections] erro em ' + name, e); }
  }

  // ---------------------------------------------------------------- cart-drawer-script: só guarda a config (funções são globais, abaixo)
  register('cartDrawerScript', function (CFG) {
    window.__beneCfg = window.__beneCfg || {}; window.__beneCfg.cartDrawerScript = CFG;
  });
  // ---------------------------------------------------------------- sections/image-with-text.liquid (2 instâncias por página → 1 código)
  register('imageWithText', function (CFG) {
    var SID = CFG.sid;

  // Init function for scroll to first section functionality (Image with Text buttons)
  function initImageTextScrollToFirst() {
    try {
      // Handle scroll-to-first-section functionality for image with text buttons
      const scrollToFirstButtons = document.querySelectorAll('.image-text-scroll-to-first[data-scroll-to-first-section]');
      console.log('🎯 Image with Text: Found ' + scrollToFirstButtons.length + ' scroll-to-first buttons');
      
      scrollToFirstButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          
          console.log('🎯 Image with Text: Scrolling to first section...');
          
          // Find the first section on the page (excluding header/navigation)
          const selectors = [
            // Most common first section patterns
            'main section:first-of-type',
            '.main-content section:first-of-type',
            '.page-content section:first-of-type',
            
            // Shopify section patterns
            '.shopify-section:not([data-section-type="header"]):not([data-section-type="announcement-bar"])',
            'section.shopify-section:not([data-section-type="header"])',
            
            // General section patterns
            'main > *:first-child',
            '.content section:first-of-type',
            'section:not(header):not([role="banner"])',
            
            // Fallback to any section
            'section:first-of-type',
            '[data-section-type]:not([data-section-type="header"])',
            
            // Last resort - any content element
            'main > div:first-child',
            '.main > *:first-child'
          ];
          
          let targetElement = null;
          let usedSelector = '';
          
          for (const selector of selectors) {
            try {
              const elements = document.querySelectorAll(selector);
              if (elements.length > 0) {
                targetElement = elements[0];
                usedSelector = selector;
                console.log(`✅ Found target using selector: ${usedSelector}`, targetElement);
                break;
              }
            } catch (error) {
              console.warn(`❌ Invalid selector: ${selector}`, error);
            }
          }
          
          if (targetElement) {
            // Calculate offset for fixed headers
            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            const stickyHeader = document.querySelector('.sticky-header, .header-sticky, [style*="position: fixed"]')?.offsetHeight || 0;
            const adminBarHeight = document.querySelector('#admin_bar_iframe, .admin-bar')?.offsetHeight || 0;
            const announcementBar = document.querySelector('.announcement-bar, .promo-bar')?.offsetHeight || 0;
            
            const offset = Math.max(headerHeight, stickyHeader) + adminBarHeight + announcementBar + 20;
            
            const elementPosition = targetElement.offsetTop;
            const offsetPosition = elementPosition - offset;
            
            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: 'smooth'
            });
            
            console.log(`✅ Image with Text: Scrolled to first section using selector: ${usedSelector}`);
            
            // Optional: Add visual highlight to show successful targeting
            targetElement.style.transition = 'all 0.3s ease';
            targetElement.style.transform = 'scale(1.01)';
            setTimeout(() => {
              targetElement.style.transform = 'scale(1)';
            }, 300);
            
          } else {
            console.warn('⚠️ Image with Text: No first section found, falling back to scroll to top');
            // Fallback: scroll to top if no target found
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });
      });
    } catch (error) {
      console.error('❌ Error initializing image with text scroll to first:', error);
    }
  }

  // Init function for scroll to product functionality
  function initScrollToProduct() {
    try {
      // Handle smooth scrolling for product links
      const scrollButtons = document.querySelectorAll('.js-scroll-to-products, [data-scroll-to-product="true"]');
      console.log('Found ' + scrollButtons.length + ' product scroll buttons');
      
      if (scrollButtons.length === 0) return;
      
      scrollButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          try {
            console.log('Button clicked: ', this);
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            console.log('Target ID: ', targetId);
            let targetElement = document.querySelector(targetId);
            console.log('Initial target element found: ', targetElement);
            
            if (targetElement) {
              // Scroll to the target element with smooth behavior
              console.log('Scrolling to specific target: ', targetElement);
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            } else {
              // Try various common product section selectors if the specific ID wasn't found
              const productSelectors = [
                // Main product selectors
                '#MainProduct',
                '#shopify-section-product-template',
                '#shopify-section-product',
                '#product-section',
                '.product-section',
                // Fallback to any product-related elements
                '.product-template',
                '.product-container',
                '.product-main',
                '.product',
                '[data-section-type="product"]',
                '[data-section-id*="product"]'
              ];
              
              console.log('Trying fallback selectors: ', productSelectors);
              
              // Try each selector until we find a match
              for (const selector of productSelectors) {
                targetElement = document.querySelector(selector);
                if (targetElement) {
                  console.log('Found product element with selector: ', selector);
                  targetElement.scrollIntoView({
                    behavior: 'smooth', 
                    block: 'start'
                  });
                  return; // Exit once we've found and scrolled to a product element
                }
              }
              
              console.log('No product selectors found, trying main content');
              
              // Final fallback: if no product section is found, try scrolling to the main content area
              targetElement = document.querySelector('main') || document.querySelector('#MainContent');
              if (targetElement) {
                console.log('Scrolling to main content: ', targetElement);
                targetElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              } else {
                console.log('No scrollable element found');
              }
            }
          } catch (err) {
            console.error('Error in scroll button click handler:', err);
          }
        });
      });
    } catch (err) {
      console.error('Error initializing scroll to product functionality:', err);
    }
  }

  // Enhanced Accordion functionality with debugging
  function initAccordions() {
    console.log('Initializing accordions...');
    const accordionContainers = document.querySelectorAll('#image-text-section-' + SID + ' .accordion-items-wrapper');
    console.log('Found', accordionContainers.length, 'accordion containers');
    
    if (accordionContainers.length === 0) {
      console.log('No accordion containers found');
      return;
    }
    
    accordionContainers.forEach((container, containerIndex) => {
      console.log(`Processing container ${containerIndex + 1}`);
      const accordionItems = container.querySelectorAll('.accordion-item');
      const accordionMode = container.getAttribute('data-accordion-mode') === 'true';
      console.log(`Container ${containerIndex + 1} has ${accordionItems.length} items, accordion mode: ${accordionMode}`);
      
      accordionItems.forEach((item, itemIndex) => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');
        
        if (!header) {
          console.log(`No header found for item ${itemIndex + 1}`);
          return;
        }
        
        if (!content) {
          console.log(`No content found for item ${itemIndex + 1}`);
          return;
        }
        
        // Skip if already initialized
        if (header.hasAttribute('data-accordion-initialized')) {
          console.log(`Item ${itemIndex + 1} already initialized, skipping`);
          return;
        }
        
        console.log(`Setting up click handler for item ${itemIndex + 1}`);
        
        // Create the click handler function
        const clickHandler = function(e) {
          console.log(`Accordion item ${itemIndex + 1} clicked!`);
          e.preventDefault();
          e.stopPropagation();
          
          const isActive = item.classList.contains('active');
          console.log(`Item ${itemIndex + 1} is currently ${isActive ? 'active' : 'inactive'}`);
          
          // If in accordion mode, close all other items
          if (accordionMode && !isActive) {
            console.log('Accordion mode: closing other items');
            accordionItems.forEach((otherItem, otherIndex) => {
              if (otherItem !== item && otherItem.classList.contains('active')) {
                console.log(`Closing item ${otherIndex + 1}`);
                otherItem.classList.remove('active');
              }
            });
          }
          
          // Toggle the current item
          if (isActive) {
            console.log(`Closing item ${itemIndex + 1}`);
            item.classList.remove('active');
          } else {
            console.log(`Opening item ${itemIndex + 1}`);
            item.classList.add('active');
          }
          
          // Trigger custom event for tracking/analytics
          try {
            container.dispatchEvent(new CustomEvent('accordion:toggle', {
              detail: {
                item: item,
                isOpen: !isActive,
                text: header.querySelector('.accordion-header-text')?.textContent
              }
            }));
          } catch (err) {
            console.error('Error dispatching accordion event:', err);
          }
        };
        
        // Add the click listener
        header.addEventListener('click', clickHandler);
        
        // Store the handler reference for potential cleanup
        header._accordionClickHandler = clickHandler;
        
        // Mark as initialized
        header.setAttribute('data-accordion-initialized', 'true');
        
        // Add visual feedback on hover
        header.style.cursor = 'pointer';
        
        // Add keyboard support
        const keyHandler = function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            console.log(`Keyboard trigger for item ${itemIndex + 1}`);
            e.preventDefault();
            clickHandler(e);
          }
        };
        
        header.addEventListener('keydown', keyHandler);
        header._accordionKeyHandler = keyHandler;
        
        // Make header focusable for accessibility
        if (!header.hasAttribute('tabindex')) {
          header.setAttribute('tabindex', '0');
        }
        
        console.log(`Item ${itemIndex + 1} setup complete`);
      });
    });
    
    console.log('Accordion initialization complete');
  }

  // Function to manually test accordion (for debugging)
  function testAccordion() {
    console.log('Testing accordion functionality...');
    const firstItem = document.querySelector('#image-text-section-' + SID + ' .accordion-item');
    if (firstItem) {
      console.log('Found first accordion item, toggling...');
      firstItem.classList.toggle('active');
      console.log('First item is now:', firstItem.classList.contains('active') ? 'active' : 'inactive');
      return true;
    } else {
      console.log('No accordion items found for testing');
      return false;
    }
  }

  // Initialize immediately if DOM is already ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('DOM Content Loaded - initializing components');
      initImageTextScrollToFirst();
      initScrollToProduct();
      initAccordions();
    });
  } else {
    // DOM is already ready
    console.log('DOM already ready - initializing components immediately');
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
  }
  
  // Also run on window load to ensure all elements are fully loaded
  window.addEventListener('load', function() {
    console.log('Window loaded - re-initializing components');
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
  });
  
  // Additional initialization for dynamic content
  document.addEventListener('shopify:section:load', function() {
    console.log('Shopify section loaded - initializing components');
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
  });

  // Backup initialization using setTimeout
  setTimeout(function() {
    console.log('Backup initialization running...');
    if (document.querySelector('#image-text-section-' + SID + ' .accordion-items-wrapper') && !document.querySelector('#image-text-section-' + SID + ' .accordion-header[data-accordion-initialized]')) {
      console.log('Found uninitialized accordions, running backup init');
      initAccordions();
    }
  }, 2000);

  // Make functions globally available for debugging
  window.debugAccordion = {
    init: initAccordions,
    test: testAccordion,
    toggle: function(index) {
      const items = document.querySelectorAll('#image-text-section-' + SID + ' .accordion-item');
      if (items[index]) {
        items[index].classList.toggle('active');
        console.log(`Manually toggled item ${index + 1}`);
      }
    }
  };

  // Final fallback: try to initialize immediately
  try {
    console.log('Immediate initialization attempt...');
    initImageTextScrollToFirst();
    initScrollToProduct();
    initAccordions();
  } catch (err) {
    console.error('Immediate initialization failed:', err);
  }

  });
  // ---------------------------------------------------------------- sections/collection-grid.liquid
  register('collectionGrid', function (CFG) {
    var SID = CFG.sid;

  // Image slider functionality
  document.addEventListener('DOMContentLoaded', function() {
    if (CFG.fullCardClickable) {
      // Full card clickable functionality
      const clickableCards = document.querySelectorAll('.section-' + SID + ' .product-card.full-card-clickable');
      
      clickableCards.forEach(card => {
        const productUrl = card.getAttribute('data-product-url');
        if (!productUrl) return;
        
        let isSliding = false;
        let startX = 0;
        let startY = 0;
        const slideThreshold = 10; // Minimum distance to consider it a swipe
        
        // Track touch/mouse start for swipe detection
        const handleStart = (e) => {
          isSliding = false;
          const touch = e.touches ? e.touches[0] : e;
          startX = touch.clientX;
          startY = touch.clientY;
        };
        
        // Track movement to detect swipes
        const handleMove = (e) => {
          if (!startX || !startY) return;
          
          const touch = e.touches ? e.touches[0] : e;
          const deltaX = Math.abs(touch.clientX - startX);
          const deltaY = Math.abs(touch.clientY - startY);
          
          // If moved more than threshold, consider it a slide
          if (deltaX > slideThreshold || deltaY > slideThreshold) {
            isSliding = true;
          }
        };
        
        // Handle card click
        const handleCardClick = (e) => {
          // Don't navigate if it was a swipe
          if (isSliding) return;
          
          // Don't navigate if clicking on links, buttons, or form elements
          const clickedElement = e.target;
          if (clickedElement.closest('a, button, input, select, textarea')) {
            return;
          }
          
          // Don't navigate if clicking on slider controls
          if (clickedElement.closest('.product-dots, .dot')) {
            return;
          }
          
          // Navigate to product page
          window.location.href = productUrl;
        };
        
        // Add event listeners
        card.addEventListener('mousedown', handleStart);
        card.addEventListener('mousemove', handleMove);
        card.addEventListener('click', handleCardClick);
        
        card.addEventListener('touchstart', handleStart, { passive: true });
        card.addEventListener('touchmove', handleMove, { passive: true });
        
        // Reset sliding state on touch end
        card.addEventListener('touchend', () => {
          setTimeout(() => { isSliding = false; }, 100);
        }, { passive: true });
        
        card.addEventListener('mouseup', () => {
          setTimeout(() => { isSliding = false; }, 100);
        });
      });
    }
    
    const sliders = document.querySelectorAll('.section-' + SID + ' .product-slider');
    
    sliders.forEach(slider => {
      const wrapper = slider.querySelector('.product-slider-wrapper');
      const slides = slider.querySelectorAll('.product-slide');
      const card = slider.closest('.product-card');
      const dots = card.querySelectorAll('.dot');
      
      if (slides.length <= 1) return; // Skip if there's only one slide
      
      let currentSlide = 0;
      const slideCount = slides.length;
      
      // Initialize dots
      updateDots();
      
      // Touch swipe functionality
      let touchStartX = 0;
      let touchEndX = 0;
      let touchStartTime = 0;
      let touchMoved = false;
      
      slider.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartTime = Date.now();
        touchMoved = false;
      }, {passive: true});
      
      slider.addEventListener('touchmove', e => {
        touchMoved = true;
      }, {passive: true});
      
      slider.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        const touchDuration = Date.now() - touchStartTime;
        
        // If it's a quick tap (less than 200ms) and didn't move much, treat as click
        if (touchDuration < 200 && !touchMoved) {
          handleImageClick();
        } else {
        handleSwipe();
        }
      }, {passive: true});
      
      // Mouse drag functionality for desktop
      let isDragging = false;
      let startPosX = 0;
      let currentTranslate = 0;
      let mouseStartTime = 0;
      let mouseMoved = false;
      
      slider.addEventListener('mousedown', e => {
        e.preventDefault();
        isDragging = true;
        startPosX = e.clientX;
        mouseStartTime = Date.now();
        mouseMoved = false;
        slider.style.cursor = 'grabbing';
      });
      
      slider.addEventListener('mousemove', e => {
        if (!isDragging) return;
        e.preventDefault();
        mouseMoved = true;
        const moveX = e.clientX - startPosX;
        const slideWidth = slider.offsetWidth;
        
        // Limit movement to prevent excessive drag
        if (Math.abs(moveX) < slideWidth * 0.5) {
          wrapper.style.transform = `translateX(${-currentSlide * (100 / slideCount) + (moveX / slideWidth * 100 / slideCount)}%)`;
        }
      });
      
      document.addEventListener('mouseup', e => {
        if (!isDragging) return;
        
        isDragging = false;
        slider.style.cursor = 'grab';
        
        const mouseDuration = Date.now() - mouseStartTime;
        const moveX = e.clientX - startPosX;
        const threshold = slider.offsetWidth * 0.2; // 20% of slide width
        
        // If it's a quick click (less than 200ms) and didn't move much, treat as click
        if (mouseDuration < 200 && !mouseMoved) {
          handleImageClick();
          return;
        }
        
        if (moveX < -threshold) {
          // Dragged left - go to next slide
          currentSlide = Math.min(currentSlide + 1, slideCount - 1);
        } else if (moveX > threshold) {
          // Dragged right - go to previous slide
          currentSlide = Math.max(currentSlide - 1, 0);
        }
        
        updateSlider();
      });
      
      document.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          slider.style.cursor = 'grab';
          updateSlider();
        }
      });
      
      function handleSwipe() {
        const threshold = 50; // Minimum swipe distance
        
        if (touchStartX - touchEndX > threshold) {
          // Swipe left - go to next slide
          currentSlide = Math.min(currentSlide + 1, slideCount - 1);
          updateSlider();
        } else if (touchEndX - touchStartX > threshold) {
          // Swipe right - go to previous slide
          currentSlide = Math.max(currentSlide - 1, 0);
          updateSlider();
        }
      }
      
      function handleImageClick() {
        // Find the product URL from the card
        const productCard = slider.closest('.product-card');
        const productLink = productCard.querySelector('.product-card-link');
        const viewProductBtn = productCard.querySelector('.collection-view-product-btn');
        
        // Get the URL from either the card link or view product button
        let productUrl = null;
        if (productLink) {
          productUrl = productLink.getAttribute('href');
          console.log('Found product link:', productUrl);
        } else if (viewProductBtn) {
          productUrl = viewProductBtn.getAttribute('href');
          console.log('Found view product button:', productUrl);
        } else {
          // Fallback: try to find any link with product URL in the card
          const allLinks = productCard.querySelectorAll('a[href*="/products/"]');
          if (allLinks.length > 0) {
            productUrl = allLinks[0].getAttribute('href');
            console.log('Found fallback product link:', productUrl);
          }
        }
        
        // Navigate to product page
        if (productUrl) {
          console.log('Navigating to:', productUrl);
          window.location.href = productUrl;
        } else {
          console.log('No product URL found');
          console.log('Product card:', productCard);
          console.log('Product link:', productLink);
          console.log('View product btn:', viewProductBtn);
        }
      }
      
      // Update slider position
      function updateSlider() {
        const slideCount = parseInt(wrapper.dataset.slideCount) || 1;
        const translateX = -currentSlide * (100 / slideCount);
        wrapper.style.transform = `translateX(${translateX}%)`;
        updateDots();
      }
      
      // Update dots
      function updateDots() {
        if (dots && dots.length) {
          dots.forEach((dot, i) => {
            if (i === currentSlide) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      }
      
      // Connect dots to slides (if they exist)
      if (dots && dots.length) {
        dots.forEach((dot, i) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            currentSlide = i;
            updateSlider();
          });
        });
      }
      
      // Add simple click handler to images as backup
      const images = slider.querySelectorAll('.product-image');
      images.forEach(img => {
        img.addEventListener('click', (e) => {
          // Only handle if not part of a drag/swipe
          if (!isDragging && !touchMoved) {
            e.preventDefault();
            e.stopPropagation();
            handleImageClick();
          }
        });
      });
    });
  });

  });
  // ---------------------------------------------------------------- sections/scrollable-ingredients-final-v2.liquid
  register('scrollableIngredients', function (CFG) {
    var SID = CFG.sid;

  (function() {
    function initSlider() {
      const slider = document.getElementById('si-slider-' + SID + '');
      const prevBtn = document.getElementById('si-prev-' + SID + '');
      const nextBtn = document.getElementById('si-next-' + SID + '');

      if (!slider || !prevBtn || !nextBtn) return;

      /* --- Scroll amount helper --- */
      function getScrollAmount() {
        const firstCard = slider.querySelector('[class*="si-card-"]');
        if (firstCard) {
          const style = window.getComputedStyle(slider);
          const gap = parseInt(style.gap) || CFG.slidesGap;
          return firstCard.offsetWidth + gap;
        }
        return 300;
      }

      /* --- Nav button state --- */
      function updateButtonStates() {
        const scrollLeft = slider.scrollLeft;
        const maxScroll = slider.scrollWidth - slider.clientWidth;

        if (scrollLeft <= 0) {
          prevBtn.classList.add('si-nav-disabled');
        } else {
          prevBtn.classList.remove('si-nav-disabled');
        }

        if (scrollLeft >= maxScroll - 1) {
          nextBtn.classList.add('si-nav-disabled');
        } else {
          nextBtn.classList.remove('si-nav-disabled');
        }
      }

      prevBtn.onclick = function() {
        if (!prevBtn.classList.contains('si-nav-disabled')) {
          slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      };

      nextBtn.onclick = function() {
        if (!nextBtn.classList.contains('si-nav-disabled')) {
          slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      };

      slider.addEventListener('scroll', updateButtonStates);
      updateButtonStates();

      /* --- Smooth drag / swipe engine --- */
      var isActive = false;
      var isMouse = false;
      var pointerStartX = 0;
      var scrollStart = 0;
      var animRaf = null;

      function cancelAnim() {
        if (animRaf) { cancelAnimationFrame(animRaf); animRaf = null; }
      }

      function disableSnap() {
        cancelAnim();
        slider.style.scrollBehavior = 'auto';
        slider.style.scrollSnapType = 'none';
      }

      function enableSnap() {
        slider.style.scrollBehavior = '';
        slider.style.scrollSnapType = '';
      }

      function smoothScrollTo(target, duration, cb) {
        cancelAnim();
        var start = slider.scrollLeft;
        var diff = target - start;
        if (Math.abs(diff) < 1) { slider.scrollLeft = target; if (cb) cb(); return; }
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var elapsed = ts - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          slider.scrollLeft = start + diff * ease;
          if (progress < 1) {
            animRaf = requestAnimationFrame(step);
          } else {
            slider.scrollLeft = target;
            animRaf = null;
            if (cb) cb();
          }
        }
        animRaf = requestAnimationFrame(step);
      }

      function snapAfterDrag() {
        var scrollAmount = getScrollAmount();
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (scrollAmount <= 0) { enableSnap(); updateButtonStates(); return; }

        /* How far did the user drag (positive = swiped toward next) */
        var totalDrag = slider.scrollLeft - scrollStart;
        /* 30px threshold — a small intentional swipe triggers navigation */
        var threshold = 30;

        var startIdx = Math.round(scrollStart / scrollAmount);
        var targetIdx = startIdx;

        if (totalDrag > threshold) {
          targetIdx = startIdx + 1;
        } else if (totalDrag < -threshold) {
          targetIdx = startIdx - 1;
        }

        /* Clamp index to valid range */
        var totalCards = slider.querySelectorAll('[class*="si-card-"]').length;
        var maxIdx = Math.max(totalCards - Math.round(slider.clientWidth / scrollAmount), 0);
        targetIdx = Math.min(Math.max(targetIdx, 0), maxIdx);

        var target = Math.min(targetIdx * scrollAmount, maxScroll);
        smoothScrollTo(target, 280, function() {
          enableSnap();
          updateButtonStates();
        });
      }

      function onPointerStart(x, mouse) {
        isActive = true;
        isMouse = mouse;
        pointerStartX = x;
        scrollStart = slider.scrollLeft;
        disableSnap();
        if (mouse) slider.style.cursor = 'grabbing';
      }

      function onPointerMove(x) {
        if (!isActive) return;
        var walk = x - pointerStartX;
        slider.scrollLeft = scrollStart - walk;
      }

      function onPointerEnd() {
        if (!isActive) return;
        isActive = false;
        if (isMouse) slider.style.cursor = '';
        snapAfterDrag();
      }

      /* --- Mouse events (desktop & theme editor) --- */
      slider.addEventListener('mousedown', function(e) {
        onPointerStart(e.pageX, true);
        e.preventDefault();
      });

      slider.addEventListener('mousemove', function(e) {
        if (!isActive || !isMouse) return;
        e.preventDefault();
        onPointerMove(e.pageX);
      });

      slider.addEventListener('mouseup', function() { if (isMouse) onPointerEnd(); });
      slider.addEventListener('mouseleave', function() { if (isMouse) onPointerEnd(); });

      /* --- Touch events (mobile + theme editor) --- */
      slider.addEventListener('touchstart', function(e) {
        onPointerStart(e.touches[0].pageX, false);
      }, { passive: true });

      slider.addEventListener('touchmove', function(e) {
        if (!isActive || isMouse) return;
        onPointerMove(e.touches[0].pageX);
      }, { passive: true });

      slider.addEventListener('touchend', function() { if (!isMouse) onPointerEnd(); }, { passive: true });
      slider.addEventListener('touchcancel', function() { if (!isMouse) onPointerEnd(); }, { passive: true });

      /* Prevent native image/link drag from interfering */
      slider.addEventListener('dragstart', function(e) { e.preventDefault(); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSlider);
    } else {
      initSlider();
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.detail.sectionId === '' + SID + '') {
          initSlider();
        }
      });
      document.addEventListener('shopify:section:select', function(event) {
        if (event.detail.sectionId === '' + SID + '') {
          initSlider();
        }
      });
      document.addEventListener('shopify:block:select', function(event) {
        if (event.detail.sectionId === '' + SID + '') {
          initSlider();
        }
      });
    }
  })();

  });
  // ---------------------------------------------------------------- sections/featured-collection-tabs-3.liquid
  register('featuredTabs3', function (CFG) {
    var SID = CFG.sid;

  function loadSwiper(callback) {
    if (window.Swiper) {
      callback();
    } else {
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      script.onload = callback;
      document.head.appendChild(script);
    }
  }

  function initFeaturedCollectionTabs3(sectionId) {
    document.querySelector(`.featured-collections-${sectionId}`).classList.remove('preview');

    const slider = new Swiper(`.featured-slider-${sectionId}`, {
      speed: 300,
      navigation: {
        nextEl: `.featured-btn-next-${sectionId}`,
        prevEl: `.featured-btn-prev-${sectionId}`,
      },
      breakpoints: {
        320: {
          spaceBetween: parseInt(document.querySelector(`.featured-slider-${sectionId}`).dataset.gapMobile || 0),
          slidesPerView: parseFloat(document.querySelector(`.featured-slider-${sectionId}`).dataset.viewMobile || 1),
        },
        768: {
          spaceBetween: parseInt(document.querySelector(`.featured-slider-${sectionId}`).dataset.gap || 0),
          slidesPerView: parseFloat(document.querySelector(`.featured-slider-${sectionId}`).dataset.view || 3),
        },
        1024: {
          spaceBetween: parseInt(document.querySelector(`.featured-slider-${sectionId}`).dataset.gap || 0),
          slidesPerView: parseFloat(document.querySelector(`.featured-slider-${sectionId}`).dataset.view || 3),
        }
      }
    });

    const sliders = document.querySelectorAll(`.featured-slider-${sectionId}`);
    const tabs = document.querySelectorAll(`.featured-tab-${sectionId}`);
    const tabsLine = document.querySelector(`.featured-tabs-line-${sectionId}`);

    if(tabs) {
      const firstTab = tabs[0];
      if (firstTab) {
        const tabRect = firstTab.getBoundingClientRect();
        const tabsContainerRect = tabsLine.parentElement.getBoundingClientRect();

        const initialLeft = tabRect.left - tabsContainerRect.left;
        const initialWidth = tabRect.width;

        tabsLine.style.setProperty('--active-tab-left', `${initialLeft}px`);
        tabsLine.style.setProperty('--active-tab-width', `${initialWidth}px`);
      }

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          sliders.forEach(slider => {
            slider.classList.remove('active')
          });
          tabs.forEach(tab => {
            tab.classList.remove('active')
          });          
           
          sliders.forEach(slider => {
            if(tab.id === slider.getAttribute('data-id')) {
              slider.classList.add('active');
              tab.classList.add('active');
      
              const tabsContainer = tab.parentElement;
              const tabRect = tab.getBoundingClientRect();
              const containerRect = tabsContainer.getBoundingClientRect();
              
              // Используем getBoundingClientRect для вычисления позиции относительно контейнера
              const newLeft = tabRect.left - containerRect.left;
              const newWidth = tab.offsetWidth;
              
              tabsLine.style.setProperty('--active-tab-left', `${newLeft}px`);
              tabsLine.style.setProperty('--active-tab-width', `${newWidth}px`);
      
              // Проверяем наличие скролла
              const hasScroll = tabsContainer.scrollWidth > tabsContainer.clientWidth;
      
            if (hasScroll) {
              const containerWidth = tabsContainer.offsetWidth;
              const scrollPosition = tab.offsetLeft - (containerWidth / 2) + (tab.offsetWidth / 2);
            
              // Smoothly scroll so the tab is centered
              tabsContainer.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
              });
            
              // After scrolling is complete (or mostly complete), update line position once
              setTimeout(() => {
                const updatedTabRect = tab.getBoundingClientRect();
                const updatedContainerRect = tabsContainer.getBoundingClientRect();
                const updatedLeft = updatedTabRect.left - updatedContainerRect.left;
                const updatedWidth = tab.offsetWidth;
            
                tabsLine.style.setProperty('--active-tab-left', `${updatedLeft}px`);
                tabsLine.style.setProperty('--active-tab-width', `${updatedWidth}px`);
              }, 300);
            }
            } else {
              slider.classList.remove('active');
              tab.classList.add('active');
            }
          })
        })        
      })
    }


  }

  function initializeAllFeaturedCollectionTabs3Sections() {
    const sections = document.querySelectorAll('[id^="shopify-section-"]');
    sections.forEach(section => {
      if (section.querySelector('.featured-' + SID + '')) {
        const sectionId = section.id.replace('shopify-section-', '');
        loadSwiper(() => initFeaturedCollectionTabs3(sectionId));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllFeaturedCollectionTabs3Sections);
  } else {
    initializeAllFeaturedCollectionTabs3Sections();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event.detail.sectionId;
      if (event.target.querySelector('.featured-' + SID + '')) {
        loadSwiper(() => initFeaturedCollectionTabs3(sectionId));
      }
    });
  }


  });
  // ---------------------------------------------------------------- sections/satisfaction-guarantee.liquid
  register('satisfactionGuarantee', function (CFG) {

document.addEventListener('DOMContentLoaded', function() {
  // Handle scroll-to-first-section functionality
  const guaranteeButtons = document.querySelectorAll('.guarantee-section__cta[data-scroll-to-first-section]');
  
  guaranteeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      console.log('🎯 Scrolling to first section...');
      
      // Find the product details section or first section on the page (excluding header/navigation)
      const selectors = [
        // Product details section (highest priority)
        '[data-section-type="product"]',
        '.shopify-section[data-section-type="product"]',
        '.product-section',
        '.shop-product-section',
        '.product-details',
        '.product-template',
        '#ProductSection',
        '#shopify-section-product-template',
        
        // Most common first section patterns
        'main section:first-of-type',
        '.main-content section:first-of-type',
        '.page-content section:first-of-type',
        
        // Shopify section patterns
        '.shopify-section:not([data-section-type="header"]):not([data-section-type="announcement-bar"])',
        'section.shopify-section:not([data-section-type="header"])',
        
        // General section patterns
        'main > *:first-child',
        '.content section:first-of-type',
        'section:not(header):not([role="banner"])',
        
        // Fallback to any section
        'section:first-of-type',
        '[data-section-type]:not([data-section-type="header"])',
        
        // Last resort - any content element
        'main > div:first-child',
        '.main > *:first-child'
      ];
      
      let targetElement = null;
      let usedSelector = '';
      
      for (let selector of selectors) {
        try {
          const elements = document.querySelectorAll(selector);
          if (elements.length > 0) {
            // Get the first element that's not a header/nav
            for (let element of elements) {
              const tagName = element.tagName.toLowerCase();
              const sectionType = element.getAttribute('data-section-type');
              
              // Skip header/navigation elements
              if (tagName === 'header' || 
                  tagName === 'nav' || 
                  sectionType === 'header' || 
                  sectionType === 'announcement-bar' ||
                  element.getAttribute('role') === 'banner') {
                continue;
              }
              
              targetElement = element;
              usedSelector = selector;
              break;
            }
            
            if (targetElement) {
              console.log(`✅ Found first section with selector: ${selector}`);
              break;
            }
          }
        } catch (e) {
          // Skip invalid selectors
          continue;
        }
      }
      
      if (targetElement) {
        // Calculate offset for fixed headers
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const stickyHeader = document.querySelector('.sticky-header, .header-sticky, [style*="position: fixed"]')?.offsetHeight || 0;
        const adminBarHeight = document.querySelector('#admin_bar_iframe, .admin-bar')?.offsetHeight || 0;
        const announcementBar = document.querySelector('.announcement-bar, .promo-bar')?.offsetHeight || 0;
        
        const offset = Math.max(headerHeight, stickyHeader) + adminBarHeight + announcementBar + 20;
        
        const elementPosition = targetElement.offsetTop;
        const offsetPosition = elementPosition - offset;
        
        window.scrollTo({
          top: Math.max(0, offsetPosition),
          behavior: 'smooth'
        });
        
        console.log(`✅ Scrolled to first section using selector: ${usedSelector}`);
        
        // Optional: Add visual highlight to show successful targeting
        targetElement.style.transition = 'all 0.3s ease';
        targetElement.style.transform = 'scale(1.01)';
        setTimeout(() => {
          targetElement.style.transform = 'scale(1)';
        }, 300);
        
      } else {
        console.warn('❌ Could not find any suitable first section to scroll to');
        console.log('🔍 Available sections on page:');
        
        // Debug: Show available sections
        const allSections = document.querySelectorAll('section, .shopify-section, main > *, .main > *');
        allSections.forEach((section, index) => {
          const tagName = section.tagName.toLowerCase();
          const id = section.id || 'no-id';
          const sectionType = section.getAttribute('data-section-type') || 'no-section-type';
          const className = section.className || 'no-class';
          
          console.log(`   ${index + 1}. <${tagName}> id="${id}" data-section-type="${sectionType}" class="${className}"`);
        });
      }
    });
  });
});

  });
  // ---------------------------------------------------------------- sections/store-faq.liquid
  register('storeFaq', function (CFG) {
    var SID = CFG.sid;

  document.addEventListener('DOMContentLoaded', function() {
    const faqContainer = document.querySelector('#store-faq-' + SID + '');
    if (!faqContainer) return;
    
    const faqItems = faqContainer.querySelectorAll('.faq-item');
    const isAccordion = faqContainer.querySelector('.faq-container').getAttribute('data-accordion') === 'true';
    
    // Set initial styles for answers so they get proper padding when activated
    faqItems.forEach(item => {
      const answer = item.querySelector('.faq-answer');
      // Store original padding values to restore when active
      answer.setAttribute('data-padding-active', '0 20px 16px');
      answer.setAttribute('data-padding-mobile-active', '0 12px 10px');
      
      const question = item.querySelector('.faq-question');
      
      // Only add event listener if it doesn't already exist to prevent conflicts
      if (!question.hasAttribute('data-store-faq-listener')) {
        question.setAttribute('data-store-faq-listener', 'true');
        
        question.addEventListener('click', () => {
          const isActive = item.classList.contains('active');
          
          // Close all other items first if accordion mode is enabled
          if (isAccordion && !isActive) {
            faqItems.forEach(otherItem => {
              otherItem.classList.remove('active');
            });
          }
          
          // Toggle the clicked item
          item.classList.toggle('active');
        });
      }
    });
    
    // Handle responsive font sizes
    function updateResponsiveFontSizes() {
      const isMobile = window.innerWidth < 750;
      
      // Apply/remove mobile class at the document level
      if (isMobile) {
        document.documentElement.classList.add('faq-mobile-view');
      } else {
        document.documentElement.classList.remove('faq-mobile-view');
      }
      
      // Apply/remove mobile class for each element
      const questions = faqContainer.querySelectorAll('.faq-question');
      const answers = faqContainer.querySelectorAll('.faq-answer');
      
      questions.forEach(question => {
        if (isMobile) {
          question.classList.add('mobile-font');
        } else {
          question.classList.remove('mobile-font');
        }
      });
      
      answers.forEach(answer => {
        if (isMobile) {
          answer.classList.add('mobile-font');
        } else {
          answer.classList.remove('mobile-font');
        }
      });
    }
    
    // Initial call and add resize listener
    updateResponsiveFontSizes();
    window.addEventListener('resize', updateResponsiveFontSizes);
  });

  });
  // ---------------------------------------------------------------- sections/statistics-grid.liquid
  register('statisticsGrid', function (CFG) {

  document.addEventListener('DOMContentLoaded', function() {
    // Function to animate circles based on percentage
    function animateStatCircles() {
      const circles = document.querySelectorAll('.stats-grid-circle');
      
      circles.forEach(circle => {
        const percentage = parseInt(circle.getAttribute('data-percentage'));
        const circumference = 2 * Math.PI * 50; // r = 50
        const progressCircle = circle.querySelector('.stats-grid-circle-progress');
        
        // Calculate the offset based on percentage
        const offset = circumference - (percentage / 100) * circumference;
        
        // Set the dash offset to show the correct percentage
        setTimeout(() => {
          progressCircle.style.strokeDasharray = circumference;
          progressCircle.style.strokeDashoffset = offset;
        }, 100);
      });
    }
    
    // Initialize the animation
    animateStatCircles();
    
    // Re-animate when they come into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateStatCircles();
        }
      });
    }, { threshold: 0.1 });
    
    document.querySelectorAll('.stats-grid-section').forEach(section => {
      observer.observe(section);
    });
  });

  });
  // ---------------------------------------------------------------- snippets/enhanced-button-effects.liquid
  register('enhancedButtons', function (CFG) {

document.addEventListener('DOMContentLoaded', function() {
  // Get theme settings
  const enableBoxShadow = CFG.boxShadow;
  const shadowIntensity = CFG.intensity;
  const enableGradient = CFG.gradient;
  const enableGradientShine = CFG.shine;
  
  // If neither effect is enabled, exit early
  if (!enableBoxShadow && !enableGradient) {
    return;
  }
  
  // Debug logging
  console.log('Enhanced Button Effects:', {
    enableBoxShadow: enableBoxShadow,
    shadowIntensity: shadowIntensity,
    enableGradient: enableGradient,
    enableGradientShine: enableGradientShine
  });
  
  // Define button selectors that should receive enhanced effects
  const buttonSelectors = [
    '.button-global-style',
    '.use-global-button-styling',
    '.button',
    '.btn',
    'button[type="submit"]',
    'input[type="submit"]',
    '.product-form__submit',
    '.shop-add-to-cart-button',
    '.cart__checkout-button',
    '.contact-button',
    '.contact__button',
    '.button--primary',
    '.claim-button',
    '.newsletter-form__button',
    '.field__button',
    '.theme-button',
    '.guarantee-section__cta',
    '.custom-hero__button'
  ];
  
  // Function to apply effects to buttons
  function applyButtonEffects() {
    buttonSelectors.forEach(selector => {
      const buttons = document.querySelectorAll(selector);
              buttons.forEach(button => {
         // Skip buttons that explicitly opt out or cart remove buttons
         // Cart remove buttons should remain simple and subtle
          if (button.classList.contains('button-section-override') || 
             button.classList.contains('no-enhanced-effects') ||
             button.classList.contains('cart-remove-button') ||
             button.classList.contains('button--tertiary') ||
             button.classList.contains('disable-global-button-styling')) {
            return;
          }
        
        // Apply box shadow effect if enabled
        if (enableBoxShadow) {
          button.classList.add('button-box-shadow');
          button.classList.add(`intensity-${shadowIntensity}`);
          console.log('Applied box shadow effect to:', button, 'with intensity:', shadowIntensity);
        }
        
        // Apply gradient effect if enabled
        if (enableGradient) {
          button.classList.add('button-gradient-effect');
          
          // Apply shine effect conditionally
          if (enableGradientShine) {
            button.classList.add('gradient-shine-enabled');
          } else {
            button.classList.remove('gradient-shine-enabled');
          }
          console.log('Applied gradient effect to:', button, 'with shine:', enableGradientShine);
        }
      });
    });
  }
  
  // Apply effects immediately
  applyButtonEffects();
  
  // Re-apply effects when new content is loaded (for AJAX/dynamic content)
  const observer = new MutationObserver(function(mutations) {
    let shouldReapply = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node contains buttons
          if (node.querySelector && buttonSelectors.some(selector => node.querySelector(selector))) {
            shouldReapply = true;
          }
          // Check if the added node itself is a button
          if (buttonSelectors.some(selector => node.matches && node.matches(selector))) {
            shouldReapply = true;
          }
        }
      });
    });
    
    if (shouldReapply) {
      setTimeout(applyButtonEffects, 50); // Small delay to ensure DOM is ready
    }
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

  });
  // ---------------------------------------------------------------- snippets/bene-delivery-estimate.liquid (prazo estimado)
  register('deliveryEstimate', function (CFG) {

(function(){
  if (window.__beneDeliveryEstimateInit) return;
  window.__beneDeliveryEstimateInit = true;

  var REGIOES = {
    sudeste: ['SP','RJ','MG','ES'],
    sul: ['PR','SC','RS'],
    centro_oeste: ['GO','MT','MS','DF'],
    norte_nordeste: ['AM','PA','RO','RR','AP','AC','TO','BA','PE','CE','PB','RN','AL','SE','PI','MA']
  };
  var ESTADOS = {
    AC:'Acre', AL:'Alagoas', AP:'Amapá', AM:'Amazonas', BA:'Bahia', CE:'Ceará', DF:'Distrito Federal', ES:'Espírito Santo',
    GO:'Goiás', MA:'Maranhão', MT:'Mato Grosso', MS:'Mato Grosso do Sul', MG:'Minas Gerais', PA:'Pará', PB:'Paraíba',
    PR:'Paraná', PE:'Pernambuco', PI:'Piauí', RJ:'Rio de Janeiro', RN:'Rio Grande do Norte', RS:'Rio Grande do Sul',
    RO:'Rondônia', RR:'Roraima', SC:'Santa Catarina', SP:'São Paulo', SE:'Sergipe', TO:'Tocantins'
  };
  var UF_POR_NOME = {};
  for (var k in ESTADOS) UF_POR_NOME[semAcento(ESTADOS[k]).toUpperCase()] = k;
  var SS_KEY = 'bene_de_ip_loc', LS_KEY = 'bene_de_cep_loc';

  function semAcento(s){ return String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,''); }
  function normUF(v){
    if (!v) return '';
    var c = semAcento(v).trim().toUpperCase();
    if (c.indexOf('BR-') === 0) c = c.slice(3);
    if (c.length === 2) return ESTADOS[c] ? c : '';
    return UF_POR_NOME[c] || '';
  }
  function regiao(uf){
    for (var k in REGIOES) if (REGIOES[k].indexOf(uf) !== -1) return k;
    return '';
  }
  function store(kind, key, val){ try{ (kind==='ss'?sessionStorage:localStorage).setItem(key, JSON.stringify(val)); }catch(e){} }
  function load(kind, key){ try{ var v=(kind==='ss'?sessionStorage:localStorage).getItem(key); return v?JSON.parse(v):null; }catch(e){ return null; } }

  function fetchTimeout(url, ms){
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var t = setTimeout(function(){ if (ctrl) ctrl.abort(); }, ms);
    return fetch(url, { method:'GET', cache:'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function(r){ clearTimeout(t); if(!r.ok) throw new Error('http '+r.status); return r.json(); });
  }
  function localizarPorIP(){
    return fetchTimeout('https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=pt', 4000)
      .then(function(d){
        if (d.countryCode && d.countryCode !== 'BR') return { city:'', uf:'', src:'ip' };
        var uf = normUF(d.principalSubdivisionCode) || normUF(d.principalSubdivision);
        return { city: d.city || d.locality || '', uf: uf, src:'ip' };
      });
  }
  function localizarPorCEP(cep){
    return fetchTimeout('https://viacep.com.br/ws/' + cep + '/json/', 6000)
      .then(function(d){
        if (!d || d.erro) throw new Error('cep');
        return { city: d.localidade || '', uf: normUF(d.uf), src:'cep' };
      });
  }

  // Tenta manter a frase em uma linha reduzindo a fonte até 12.5px.
  // Se mesmo assim não couber (cidade muito longa), volta ao tamanho normal e deixa quebrar.
  function ajustarLinha(el){
    el.style.fontSize = ''; el.style.whiteSpace = 'nowrap';
    var base = parseFloat(getComputedStyle(el).fontSize), size = base, guard = 0;
    while (el.scrollWidth > el.clientWidth + 1 && size > 12.5 && guard++ < 8) {
      size -= 0.5; el.style.fontSize = size + 'px';
    }
    if (el.scrollWidth > el.clientWidth + 1) { el.style.fontSize = ''; el.style.whiteSpace = 'normal'; }
  }

  function initBloco(el){
    var titleEl = el.querySelector('[data-de-title]');
    var subEl = el.querySelector('[data-de-sub]');
    var cepLink = el.querySelector('[data-de-cep-toggle]');
    if (!titleEl || !subEl) return;
    var ds = el.dataset;
    var prazos = { sudeste: ds.prazoSudeste, sul: ds.prazoSul, centro_oeste: ds.prazoCentroOeste, norte_nordeste: ds.prazoNorteNordeste };

    function render(loc){
      var uf = loc && loc.uf, reg = regiao(uf);
      if (!reg) {
        titleEl.textContent = ds.fallback; subEl.textContent = ds.fallbackSub;
        if (cepLink) cepLink.textContent = ds.cepLink;
        ajustarLinha(titleEl); return;
      }
      var prazo = prazos[reg], exato = loc.src === 'cep' || loc.src === 'customer', frase;
      if (exato && loc.city)                          frase = ' em ' + loc.city + ' - ' + uf;      // CEP/cliente: cidade exata
      else if (ds.ipMode === 'region' && loc.city)    frase = ' para ' + loc.city + ' ' + ds.regionSuffix; // IP: "Blumenau e região"
      else if (ds.ipMode === 'city' && loc.city)      frase = ' em ' + loc.city + ' - ' + uf;
      else                                            frase = ' em ' + ESTADOS[uf];                // sem cidade: estado
      titleEl.textContent = ds.prefix + ' ' + prazo + frase;
      subEl.textContent = ds.subtext;
      if (cepLink) cepLink.textContent = (loc.src === 'cep') ? ds.cepChange : ds.cepLink;
      ajustarLinha(titleEl);
    }

    // Prioridade: CEP salvo → cliente logado → IP desta sessão → consulta IP
    var salvo = load('ls', LS_KEY);
    if (salvo && salvo.uf) render(salvo);
    else if (ds.custUf && normUF(ds.custUf)) render({ city: ds.custCity, uf: normUF(ds.custUf), src:'customer' });
    else {
      var ip = load('ss', SS_KEY);
      if (ip && ip.uf) render(ip);
      else localizarPorIP().then(function(loc){ store('ss', SS_KEY, loc); render(loc); })
                           .catch(function(){ render(null); });
    }
    window.addEventListener('resize', function(){ ajustarLinha(titleEl); });

    // CEP manual
    var form = el.querySelector('[data-de-cep-form]');
    var input = el.querySelector('[data-de-cep-input]');
    var err = el.querySelector('[data-de-cep-error]');
    if (cepLink && form && input) {
      cepLink.addEventListener('click', function(){ form.hidden = !form.hidden; if (!form.hidden) input.focus(); });
      input.addEventListener('input', function(){
        var v = input.value.replace(/\D/g,'').slice(0,8);
        input.value = v.length > 5 ? v.slice(0,5) + '-' + v.slice(5) : v;
        if (err) err.hidden = true;
      });
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var cep = input.value.replace(/\D/g,'');
        if (cep.length !== 8) { if (err){ err.textContent='Digite os 8 dígitos do CEP'; err.hidden=false; } return; }
        var btn = form.querySelector('button'); if (btn) btn.disabled = true;
        localizarPorCEP(cep)
          .then(function(loc){ if (!loc.uf) throw new Error('uf'); store('ls', LS_KEY, loc); render(loc); form.hidden = true; })
          .catch(function(){ if (err){ err.textContent='CEP não encontrado'; err.hidden=false; } })
          .then(function(){ if (btn) btn.disabled = false; });
      });
    }
  }

  function initAll(){ document.querySelectorAll('[data-bene-de]').forEach(function(el){ if(!el.__deInit){ el.__deInit=true; initBloco(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  });

  // processa o que as sections registraram durante o parse e recebe novos registros (editor de temas)
  var q = window.__beneQueue || [];
  window.beneRun = run;
  for (var i = 0; i < q.length; i++) run(q[i][0], q[i][1]);
  window.__beneQueue = [];
})();

// ---------------------------------------------------------------- snippets/cart-drawer-script.liquid: funções globais (cart.js chama initUpsellOnCart após re-renderizar o carrinho)

  window.initUpsellOnCart = function () {
        var CFG = (window.__beneCfg && window.__beneCfg.cartDrawerScript) || {currency:'', btnColor:'#FFFFFF', successText:null};
        const parser = new DOMParser();

        const formIdList = [
          "cart-upsell-form-1",
          "cart-upsell-form-2",
          "cart-upsell-form-3",
          "cart-upsell-form-4",
          "cart-upsell-form-5",
        ];

        formIdList.forEach((_formId) => {
          const form = document.getElementById(_formId);
          if (form) {
              // Setup variant selection
              const selects = form.querySelectorAll('select[name^="options["]');
              const hiddenIdInput = form.querySelector('input[name="id"]');
              const productJson = JSON.parse(form.querySelector("#upsell-product-json").text);

              const updateVariantId = () => {
                  let selectedOptions = [];
                  selects.forEach(select => {
                    selectedOptions.push(select.value);
                  });
                  
                  if (productJson.variants) {
                  const selectedVariant = productJson.variants.find(variant => {
                      return selectedOptions.every((option, index) => {
                      return variant.options[index] === option;
                      });
                  });

                  if (selectedVariant) {
                      hiddenIdInput.value = selectedVariant.id;
                      // Update button text with new variant price
                      const buttonTextElement = form.querySelector('.upsell-button-text');
                      if (buttonTextElement && selectedVariant.price) {
                      // Use Shopify's money format for the current market/currency
                      const currentCurrency = CFG.currency;
                      
                      // Convert price from cents to currency units
                      const price = selectedVariant.price / 100;
                      
                      // Format based on current currency
                      let formattedPrice;
                      if (currentCurrency === 'USD') {
                          // US format: $9.95
                          formattedPrice = '$' + price.toFixed(2);
                      } else if (currentCurrency === 'EUR') {
                          // European format: €9,95
                          formattedPrice = '€' + price.toFixed(2).replace('.', ',');
                      } else if (currentCurrency === 'GBP') {
                          // British format: £9.95
                          formattedPrice = '£' + price.toFixed(2);
                      } else if (currentCurrency === 'CAD') {
                          // Canadian format: $9.95 CAD
                          formattedPrice = '$' + price.toFixed(2) + ' CAD';
                      } else {
                          // Generic fallback: CURRENCY 9.95
                          formattedPrice = currentCurrency + ' ' + price.toFixed(2);
                      }
                      
                      // Wrap price in span with price color
                      buttonTextElement.innerHTML = '+<span class="upsell-price" style="color: ' + CFG.btnColor + '">' + formattedPrice + '</span>';
                      }
                  }
                  }
              };

              selects.forEach(select => {
                  select.addEventListener('change', updateVariantId);
              });
              
              // Initialize
              if (selects.length > 0) {
                  updateVariantId();
              }
          }
        });

        const cartDrawerContainer = document.querySelector("cart-drawer");
        const submitButtonList = document.querySelectorAll(
          '.upsell-product-container button[name="upsell-add"]'
        );

        submitButtonList.forEach((submitButton) => {
          submitButton.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const form = submitButton.closest(".upsell-form");

            const addButton = form.querySelector(`.upsell-add-button`);
            const originalButtonText = addButton.querySelector(
              ".upsell-button-text"
            ).textContent;

            // Show loading state - replace text with spinner
            addButton.innerHTML = '<span class="button-spinner"></span>';
            addButton.classList.add("is-loading");
            addButton.disabled = true;

            // Get the variant ID
            const hiddenIdInput = form.querySelector('input[name="id"]');
            const variantId = hiddenIdInput.value;

            try {
              // Add to cart using fetch API
              fetch(`${window.routes.cart_add_url}.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                    },
                  ],
                }),
              })
                .then((response) => {
                  if (!response.ok) {
                    return response.json().then((errorData) => {
                      throw new Error(
                        `Error ${response.status}: ${
                          errorData.description || response.statusText
                        }`
                      );
                    });
                  }
                  return response.json();
                })
                .then((data) => {
                  // Success - restore button content properly
                  const successText = CFG.successText;

                  addButton.innerHTML =
                    '<span class="upsell-button-text">' +
                    (successText ?? originalButtonText) +
                    "</span>";
                  addButton.classList.remove("is-loading");
                  addButton.classList.add("upsell-add-success");

                  setTimeout(() => {
                    addButton.innerHTML = '<span class="upsell-button-text">' +
                    originalButtonText +
                    "</span>";
                  }, 2000);

                  // Update cart count and drawer (existing logic here)
                  if (typeof window.updateCartCount === "function") {
                    window.updateCartCount();
                  }
                  if (typeof window.refreshCart === "function") {
                    window.refreshCart();
                  }
                  document.dispatchEvent(new CustomEvent("cart:refresh"));
                  document.dispatchEvent(new CustomEvent("cart:update"));
                  if (
                    typeof window.THEME !== "undefined" &&
                    window.THEME.updateCartCount
                  ) {
                    window.THEME.updateCartCount();
                  } else if (typeof window.refreshMiniCart === "function") {
                    window.refreshMiniCart();
                  }

                  fetch(routes.cart_url + "?view=drawer")
                    .then((response) => response.text())
                    .then((html) => {
                      const parsedCartHtml = parser.parseFromString(
                        html,
                        "text/html"
                      );
                      const newCartDrawer =
                        parsedCartHtml.querySelector("#CartDrawer");
                      if (cartDrawerContainer && newCartDrawer) {
                        updateCartDrawer(cartDrawerContainer, newCartDrawer);
                      }
                    });

                  // Reset button after 2 seconds
                  setTimeout(() => {
                    addButton.disabled = false;
                    addButton.classList.remove("upsell-add-success");
                  }, 2000);
                })
                .catch((error) => {
                  console.error("Add to cart error:", error);
                  addButton.innerHTML =
                    '<span class="upsell-button-text">' +
                    originalButtonText +
                    "</span>";
                  addButton.classList.remove("is-loading");
                  addButton.classList.add("upsell-add-error");

                  // Reset button after 2 seconds
                  setTimeout(() => {
                    addButton.disabled = false;
                    addButton.classList.remove("upsell-add-error");
                  }, 2000);
                });
            } catch (err) {
              console.error("Synchronous error in form submission:", err);
              addButton.innerHTML =
                '<span class="upsell-button-text">' + originalButtonText + "</span>";
              addButton.classList.remove("is-loading");
              addButton.disabled = false;
            }

            return false; // Explicitly return false to be absolutely sure
          });
        });

        const sliderContainer = document.querySelector('.upsell_slider');
        if (!sliderContainer) return;

        const slider = sliderContainer.querySelector('.upsell_block_container');
        const dotsContainer = sliderContainer.querySelector('.dots-and-arrows');
        const dots = dotsContainer.querySelectorAll('.slide_item');
        const prevArrow = dotsContainer.querySelector('#slide-arrow-prev');
        const nextArrow = dotsContainer.querySelector('#slide-arrow-next');
        
        if (!slider || !dotsContainer || !prevArrow || !nextArrow) return;

        let slideWidth = 0;

        const calculateSlideWidth = () => {
          const firstSlide = slider.querySelector('.upsell-product-container');
          if (firstSlide) {
            slideWidth = firstSlide.offsetWidth;
          }
        };

        const updateDots = () => {
          calculateSlideWidth();
          if (slideWidth === 0) return;

          const activeIndex = Math.round(slider.scrollLeft / slideWidth);
          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
          });
        };

        // Use Intersection Observer to run logic only when cart is visible
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            calculateSlideWidth();
            updateDots();
          }
        }, { threshold: 0.1 });

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          observer.observe(cartDrawer);
        }

        slider.addEventListener('scroll', updateDots);
        window.addEventListener('resize', updateDots);

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            if (slideWidth === 0) calculateSlideWidth();
            slider.scrollTo({
              left: index * slideWidth,
              behavior: 'smooth'
            });
          });
        });

        prevArrow.addEventListener('click', () => {
          if (slideWidth === 0) calculateSlideWidth();
          slider.scrollBy({ left: -slideWidth, behavior: 'smooth' });
        });

        nextArrow.addEventListener('click', () => {
          if (slideWidth === 0) calculateSlideWidth();
          slider.scrollBy({ left: slideWidth, behavior: 'smooth' });
        });

        const slideItems = document.querySelectorAll(".slide_item");
        // Optional function to update active dot styling
        function updateActiveDot(activeSlide) {
          slideItems.forEach((item) => {
            if (parseInt(item.getAttribute("data-slide")) === activeSlide) {
              item.classList.add("active");
            } else {
              item.classList.remove("active");
            }
          });
        }

        // Select the slider container
        const upsellContainer = document.querySelector(".upsell_block_container");
        if (!upsellContainer) return;
        // Add click event to each dot
        slideItems.forEach((item) => {
          item.addEventListener("click", function () {
            const slideIndex = parseInt(this.getAttribute("data-slide")) - 1;
            // Calculate scroll position
            const scrollPosition = slideIndex * slideWidth;
            // Smooth scroll to the selected slide
            sliderContainer.scrollTo({
              left: scrollPosition,
              behavior: "smooth",
            });
            // Optional: Update active dot styling
            updateActiveDot(slideIndex + 1); // Convert back to 1-based for data-slide
          });
        });
      }

 
  window.detectDiscountWrap = function () {
    const container = document.querySelector('.cart-drawer .discount_price-container');
    const discount = container?.querySelector('.discount_discount-value');
    const price = container?.querySelector('.totals__total-value');

    if (!container || !discount || !price) return;
    const discountTop = discount.getBoundingClientRect().top;
    const priceTop = price.getBoundingClientRect().top;
    console.log(discountTop, priceTop);
    if (discountTop + 5 < priceTop) {
      container.classList.add('wrap');
    } else {
      container.classList.remove('wrap');
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    initUpsellOnCart();
    detectDiscountWrap();
  });

